import StarRating from '../starRating';

import "./index.scss";
import Reviews from "./reviews";

const DataReviews = () => {

    const dateReviews = Reviews.map((assessment) => 
       <div className="container-reviews-users" key={assessment.id}>
            <h3>{assessment.name}</h3>
            <img  src={assessment.photo} alt="fotos usuarios" loading="lazy" />
            <p className="review">{assessment.review}</p>

            <p className="stars-review">
                <StarRating rating={assessment.stars} />
                <span>{assessment.stars} estrelas</span>
            </p>
       </div>)


    return (
        <>
            <div className="title-reviews">
                <h2>Avaliações</h2>
                <div className="container-reviews">
                    {dateReviews}
                </div>

            </div>
        
        </>
    )
}

export default DataReviews;